import React, { useState } from "react";
import FAQPopup from "./FAQPopup";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isFAQOpen, setIsFAQOpen] = useState(false);
  return (
    <>
      <a className="skip-link" href="#main-content">Skip to content</a>
      <header className="site-header">
        <div className="nav-inner">
          <a href="#main-content" className="brand" aria-label="Radiant Light Healing home">
            <img src="./fulllogo_transparent.png" alt="" />
            <span>Radiant Light Healing<small>REIKI & WELL-BEING</small></span>
          </a>
          <button className="menu-toggle" aria-label={menuOpen ? "Close menu" : "Open menu"} aria-expanded={menuOpen} aria-controls="main-navigation" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? "✕" : "☰"}</button>
          <nav id="main-navigation" aria-label="Main navigation" className={`site-nav ${menuOpen ? "is-open" : ""}`}>
            {[["about", "About"], ["reiki", "Reiki"], ["testimonials", "Kind words"], ["pricing", "Sessions"]].map(([id, label]) => <a key={id} href={`#${id}`} onClick={() => setMenuOpen(false)}>{label}</a>)}
            <button onClick={() => { setIsFAQOpen(true); setMenuOpen(false); }}>FAQs</button>
            <a className="button-primary" href="#contact-us" onClick={() => setMenuOpen(false)}>Get in touch <span aria-hidden="true">↗</span></a>
          </nav>
        </div>
      </header>
      <FAQPopup isOpen={isFAQOpen} closePopup={() => setIsFAQOpen(false)} />
    </>
  );
}
